import { Ghost } from "lucide-react";
interface IncognitoModeUserPictureProps {
  className?: string;
}

export const IncognitoModeUserPicture = ({
  className = "w-6 h-6",
}: IncognitoModeUserPictureProps) => {
  return (
    <div
      className={`flex items-center justify-center rounded-full bg-bg-subtle ${className}`}
    >
      <Ghost className="w-4 h-4 text-fg-base" />
    </div>
  );
};

export default IncognitoModeUserPicture;
